/* eslint-disable react/display-name */
import * as React from 'react';

const FacebookSocial = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M34.753 58H21.981V29.997H15.6v-9.649h6.381v-5.793C21.981 6.684 25.584 2 35.821 2h8.521v9.652h-5.325c-3.986 0-4.25 1.349-4.25 3.865l-.017 4.83h9.649l-1.129 9.649h-8.52V58h.003z" />
  </svg>
);

export default FacebookSocial;
